module.exports = __webpack_public_path__ + "img/banner-aisla-forte.1a2b52a5.png";